import * as React from 'react';
import { cn } from './lib/utils';

const Input = React.forwardRef(({ className, type, ...props }, ref) => (
  <input
    type={type}
    className={cn(
      'flex h-8 w-full rounded border border-nn-border bg-nn-white px-3 py-1.5',
      'text-body text-text-dark placeholder:text-text-muted',
      'transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-aqua focus-visible:border-aqua',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'dark:bg-navy-mid dark:border-white/10 dark:text-text-primary',
      className
    )}
    ref={ref}
    {...props}
  />
));
Input.displayName = 'Input';

export { Input };
